import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'
import { useMediaQuery } from 'usehooks-ts'

import { useModalStore } from '@features/modal'

import Button from '@shared/ui/button'
import { formatDayMonth } from '@shared/uttils/formatDayMonth'

import QrModal from './QrModal'

import styles from './styles.module.scss'

interface IItemProps {
  title: string
  description: string
  validTo?: string
  imageUrl?: string
  canBeActivated?: boolean
  qrCode?: string | null
}

export default function Item (props: IItemProps) {
  const { title, description, validTo, imageUrl, canBeActivated, qrCode } = props
  const isMobile = useMediaQuery('(max-width: 767px)')
  const { t: tn } = useTranslation('personal')
  const { t: tc } = useTranslation('common')
  const { openModal } = useModalStore()

  const handleShowQR = () => {
    if (qrCode) {
      openModal(
        'couponQr',
        <QrModal 
          title={title} 
          description={description}
          validTo={validTo}
          qrCode={qrCode}
        />,
        {
          title: tc('qr_code'),
        }
      )
    }
  }

  return (
    <div className={styles.item}>
      <div className={styles.item__left}>
        <div className={styles.item__meta}>
          { validTo && (
            <div className={styles.item__data}>
              {tc('up_to')} {formatDayMonth(validTo)}
            </div>
          )}
        </div>
        <h4 className={styles.item__title}>{title}</h4>
        <p className={styles.item__description}>{description}</p>
        {canBeActivated && (
          <Button
            size={!isMobile ? 'large' : 'medium'}
            theme="white"
            className={styles.item__activity}
          >
            {tn('activate')}
          </Button>
        )}
      </div>
      <div className={styles.item__right}>
        {qrCode && (
          <Button theme="white" className={styles.item__qr} onClick={handleShowQR}>
            <ReactSVG src="/icons/qrcode.svg" />
          </Button>
        )}
        {imageUrl && (
          <img src={imageUrl} alt={title} className={styles.item__image} />
        )}
      </div>
    </div>
  )
}
